/* eslint react/jsx-key: off */
import React from "react";
import ReactDOM from "react-dom";
import { Route, HashRouter as Router } from "react-router-dom";
import { routerMiddleware, connectRouter } from "connected-react-router";
import { createStore, applyMiddleware, combineReducers } from "redux";
import { Provider } from "react-redux";
import thunkMiddleware from "redux-thunk";
import { createHashHistory } from "history";

import { setupWebsocket } from "./store/actions/websocket";

import scoreboardReducer from "./store/reducer/scoreboard";
import ContextContainer from './components/ContextContainer/ContextContainer';
import Players from './components/pages/Players/Players';
import { DartsDebug } from './components/pages/Debug/Debug';

import "./assets/css/global.scss";

const history = createHashHistory();
const rootReducer = combineReducers({
  router: connectRouter(history),
  scoreboard: scoreboardReducer,
});

const setupStore = () => {
  const middleware = [];

  if (process.env.NODE_ENV === "development") {
    const { createLogger } = require("redux-logger");
    middleware.push(createLogger());
  }

  return setupWebsocket().then(({ send, receive }) => {
    middleware.push(routerMiddleware(history));
    middleware.push(thunkMiddleware.withExtraArgument({ send }));
    const store = createStore(
      rootReducer,
      {},
      applyMiddleware(...middleware),
      history
    );

    receive(store.dispatch);
    return { store, send };
  });
};
setupStore().then(({ store, send }) => {
  ReactDOM.render(
    <Provider store={store}>
      <Router>
        <Route
          exact
          path="/"
          component={(props) => <ContextContainer {...props} />}
          noLayout
        />
        <Route
          exact
          path="/players"
          component={(props) => <Players {...props} send={send} />}

          noLayout
        />
        <Route
          path="/debug"
          component={(props) => <DartsDebug {...props} send={send} />}
          noLayout
        />
      </Router>
    </Provider>,
    document.getElementById("root")
  );
});
